import React from "react";

const PersonaIcon = ({ highlighted }) => {
  return (
    <img
      className="h-[1.1rem] w-[1.1rem]"
      src={
        highlighted
          ? require("../assets/Group-1.png")
          : require("../assets/Group 1.png")
      }
    />
  );
};

export default PersonaIcon;
